import { Component } from '@angular/core';

@Component({
  selector: 'ppa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'PathePayment_App';
}
